/**
 * Mixin for Movie Overview, Movie Heading, Banner Movie Hero, Poster Movie Hero and Register Movie Hero components
 */

export default {
  props: {
    movieId: {
      type: Number,
      required: false,
      default: null
    }
  },
  configuration: ['currentSite', 'sites'],
  models: {
    findMovieBySlug: {
      userMovies: 'default',
      variables () {
        return {
          urlSlug: this.computedMovieSlug,
          siteIds: this.movieQuerySiteIds,
          skip: !this.computedMovieSlug
        }
      },
      immediate: true
    }
  },
  computed: {
    movieQuerySiteIds () {
      if (!this.currentSite.consumerConfig.showMoviesAndShowingsForMultipleSites) return []

      const movieQuerySites = _.filter(this.sites.data, site => !site.isLibrary && (site.consumerConfig && !site.consumerConfig.hideOnLocationSelectPage))
      return _.map(movieQuerySites, 'id')
    },
    computedMovieSlug () {
      return this.movieId ? this.movieId.toString() : this.$route.params.slug
    }
  }

}
